import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

// Reusable vertical/marketing page hero
export function PageHero({ overline, title, subtitle, image }) {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden" data-testid="page-hero">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
        </div>
      )}
      <div className="relative max-w-7xl mx-auto px-6">
        <p className="overline text-[#CC5500]">{overline}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mt-4 max-w-3xl leading-[1.05]">
          {title}
        </h1>
        {subtitle && <p className="text-neutral-300 text-lg mt-6 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
